import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class hivestack
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.hivestack = {};

/**
 * Gets Hivestack UUID
 * @param {ReachAPI.Security} security
 * @param {number} widgetId
 * @throws {ReachApiError}
 * @returns {Promise<ReachApiResponse>}
 * @memberof ReachAPI.hivestack
 */
ReachAPI.hivestack.getCredentials = function (security, widgetId) {
    var url = ReachAPI.server + '/signage/hivestack/credentials/' + widgetId;
    var params = {};
    var jqPromise;

    params = security.merge(params);
    jqPromise = ReachAPI.get(url, 'json', params);

    jqPromise.done(function () {
        Log.Debug('Retrieved Hivestack UUID from the REACH API', null, __fileline);
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Hivestack UUID',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return ReachAPI.deferredToPromise(jqPromise);
};
